import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "services-page" }
const _hoisted_2 = { class: "page-header" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "actions" }
const _hoisted_5 = { class: "box" }
const _hoisted_6 = { class: "box-list" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "box-list-item-title" }
const _hoisted_9 = ["innerHTML"]

import { computed, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";
import store from "@/store";

import { toast } from "@/common/utils/toast";

import { categoryList, categoryAdd } from "@/common/api/rest/category";

import type {
  CategoryType,
  CategoryPayloadType,
} from "@/common/types/category";

import { PanelTheme } from "@/common/themes";
import { FormCategory } from "@/components";
import {
  baseAvatar,
  baseConfirm,
  baseModal,
  svgIcon,
} from "@/common/components";


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const { t } = useI18n();
const router = useRouter();

const listCategory = ref<CategoryType[]>([]);
const payload = ref<CategoryPayloadType | null>(null);

const showModalAdd = ref(false);
const payloadValid = ref(false);

function fetchData() {
  categoryList("SERVICES")
    .then((response) => {
      const { success, data, message } = response;

      if (success) {
        listCategory.value = data.list;
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function addItem() {
  showModalAdd.value = true;
}

function addItemCancel() {
  showModalAdd.value = false;
  payload.value = null;
}

function addItemConfirm() {
  if (!payload.value) return;

  store.commit("SET_LOADING", true);

  categoryAdd(payload.value)
    .then((response) => {
      const { success, message } = response;

      if (success) {
        fetchData();
        addItemCancel();
        toast({ message: message, type: "success" });
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    })
    .finally(() => {
      store.commit("SET_LOADING", false);
    });
}

function goToCategory(category_id: string) {
  router.push(`/services/${category_id}/edit`);
}

onMounted(() => {
  fetchData();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createVNode(_unref(PanelTheme), null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_unref(svgIcon), {
              icon: "services",
              size: "2rem"
            }),
            _createTextVNode(" " + _toDisplayString(_unref(t)("common.labels.services")) + " | " + _toDisplayString(_unref(t)("category.labels.categories")), 1)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("button", {
              class: "btn btn-md btn-primary",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (addItem()))
            }, [
              _createVNode(_unref(svgIcon), {
                icon: "add",
                size: "1.25rem"
              }),
              _createTextVNode(" " + _toDisplayString(_unref(t)("category.labels.category").toUpperCase()), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listCategory.value, (category) => {
              return (_openBlock(), _createElementBlock("div", {
                key: category.category_id,
                class: "box-list-item",
                onClick: ($event: any) => (goToCategory(category.category_id))
              }, [
                _createElementVNode("div", _hoisted_8, _toDisplayString(category.name), 1),
                _createElementVNode("div", {
                  class: "box-list-item-description",
                  innerHTML: category.description
                }, null, 8, _hoisted_9)
              ], 8, _hoisted_7))
            }), 128))
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_unref(baseModal), {
      show: showModalAdd.value,
      title: _unref(t)('category.modals.titles.add_category').toUpperCase(),
      "show-button-confirm": true,
      "button-confirm": _unref(t)('common.labels.save'),
      "button-close": _unref(t)('common.labels.cancel'),
      onClose: _cache[3] || (_cache[3] = ($event: any) => (addItemCancel())),
      onConfirm: _cache[4] || (_cache[4] = ($event: any) => (addItemConfirm()))
    }, {
      content: _withCtx(() => [
        _createVNode(_unref(FormCategory), {
          type: "SERVICES",
          "onUpdate:data": _cache[1] || (_cache[1] = ($event: any) => (payload.value = $event)),
          onValidate: _cache[2] || (_cache[2] = ($event: any) => (payloadValid.value = $event))
        })
      ]),
      _: 1
    }, 8, ["show", "title", "button-confirm", "button-close"])
  ]))
}
}

})